<template>
  <main>
    <LoadingSpinner :isPageLoading="isPageLoading" />
    <template v-if="!isAuthLoading">
      <NavBar id="DesktopNavBar" v-show="showHeader" />
      <MobileNavBar id="MobileNavBar" v-show="showHeader" />
      <transition
        name="fade"
        mode="out-in"
        @beforeLeave="beforeLeave"
        @enter="enter"
        @afterEnter="afterEnter"
      >
        <router-view :key="$route.fullPath" />
      </transition>
      <Footer v-show="showHeader" />
    </template>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'
import { getToken } from '@/helpers'
import LoadingSpinner from '@/components/layout/LoadingSpinner.vue'
import NavBar from '@/components/layout/navbar/NavBar.vue'
import MobileNavBar from '@/components/layout/navbar/MobileNavBar.vue'
import Footer from '@/components/layout/Footer.vue'

export default {
  name: 'App',
  data() {
    return {
      loggedIn: false,
      showHeader: true,
      routeName: '',
      right: false,
      noHeaderRoutes: [
        'login',
        'reset-password',
        'signup',
        'admin',
        'two-factor',
      ],
    }
  },
  components: {
    LoadingSpinner,
    NavBar,
    MobileNavBar,
    Footer,
  },
  computed: {
    ...mapGetters({
      isPageLoading: 'app/isPageLoading',
      isAuthenticated: 'auth/isAuthenticated',
      isAuthLoading: 'auth/isAuthLoading',
      appError: 'app/appError',
      appNotification: 'app/appNotification',
      profile: 'auth/userProfile',
      memberId: 'auth/memberId',
      userActiveSubscription: 'user/activeSubscriptions',
      userId: 'auth/userId',
      isCordova: 'app/isCordova',
    }),
    userEmail() {
      const { email } = this.profile
      return email
    },
  },
  watch: {
    routeName(name) {
      if (this.noHeaderRoutes.includes(name)) {
        this.showHeader = false
      } else {
        this.showHeader = true
      }
    },
    appError(error) {
      if (error && error.length) {
        this.$toasted.global.appError({
          message: error,
        })
        this.$store.dispatch('app/setError', '')
      }
    },
    appNotification(notification) {
      if (notification && notification.length) {
        this.$toasted.global.appNotification({
          message: notification,
        })
        this.$store.dispatch('app/setNotification', '')
      }
    },
  },
  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter(element) {
      const height = getComputedStyle(element)

      element.style.height = this.prevHeight

      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter(element) {
      element.style.height = 'auto'
    },
    logWithProfitwell() {
      if (this.userEmail && this.userEmail !== '') {
        try {
          window.dataLayer.push({
            event: 'start_pw',
            pw_user_email: this.userEmail,
          })
        } catch (e) {
          console.log(e)
        }
      } else {
        try {
          window.dataLayer.push({ event: 'start_pw' })
        } catch (e) {
          console.log(e)
        }
      }
    },
  },
  async created() {
    const token = await getToken()
    if (token) {
      this.$store.dispatch('auth/setIsAuthLoading', true)
      await this.$store.dispatch('auth/tryAutoLogin')
      this.$store.dispatch('auth/setIsAuthLoading', false)
    }
    this.logWithProfitwell()
    await this.$store.dispatch('categories/getCategories')
    await this.$store.dispatch('presenters/getPresenters')
  },
  mounted() {
    if (this.isCordova) {
      setTimeout(() => {
        window.navigator.splashscreen.hide()
      }, 1000)
    }
  },
  updated() {
    this.routeName = this.$route.name
  },
}
</script>

<style lang="scss">
// Account for notches and statusbars
body {
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  scroll-behavior: smooth;
}
@import './src/styles/app.scss';
@import '~swiper/dist/css/swiper.css';
</style>
